import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useExcelExport from '../../../hooks/useExcelExport';
import { useDataAuth } from '../../../hooks/useDataAuth';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import GetAppIcon from '@mui/icons-material/GetApp';
import IconButton from '@mui/material/IconButton';
import { LoadButtonHeaderTable } from '../../../components/sharedViews/loadActionsHeader/LoadButtonHeaderTable';
import { DialogSelectCompany } from '../../../components/dialogs/DialogSelectCompany';
import ComplexColumnChart from '../components/charts/ComplexColumnChart';
import StackedColumnChart from '../components/charts/StackedColumnChart';
import LoadingOverlay from '../../../components/others/LoadingOverlay';
import SimpleColumnChart from '../components/charts/SimpleColumnChart';
import FunnelChart from '../components/charts/FunnelChart';
import GridPivot from '../components/gridPivot/GridPivot';
import AreaChart from '../components/charts/AreaChart';
import LineChart from '../components/charts/LineChart';
import PieChart from '../components/charts/PieChart';
import { ensureArray } from '../../../utils/validateResponseApi';
import { callApi } from '../../../services/api.service';
import "@progress/kendo-theme-default/dist/all.css";
import { safeParseJSON } from '../../../utils/jsonValidator';
import StatCard from '../components/card/StatCard';
import DoughnutChart from '../components/charts/DoughnutChart';
import BarGroupChart from '../components/charts/BarGroupChart';
import BarChart from '../components/charts/BarChart';
import SimpleLineChart from '../components/charts/SimpleLineChart';

export const LayoutCharts = ({ conf = null }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [{ userSession }] = useDataAuth();
    const { exportToExcel } = useExcelExport();
    const chartRefs = useRef({});
    const [cfg, setcfg] = useState({});
    const [filters, setfilter] = useState({});
    const [charts, setCharts] = useState([]);
    const [buttons, setButtons] = useState([]);
    const [openDialogCompany, setOpenDialogCompany] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(true);
    const parseConfiguration = (configuration) => {
        if (!configuration) return { charts: [], buttons: [] };
        try {
            const parsed = safeParseJSON(configuration);
            return {
                charts: parsed?.charts || [],
                buttons: parsed?.button || [],
            };
        } catch (e) {
            return { charts: [], buttons: [] };
        }
    };

    useEffect(() => {
        const config = location.state?.configuration || conf?.configuration;
        if (config) {
            setcfg(conf);
            const { charts, buttons } = parseConfiguration(config);
            setCharts(charts);
            setButtons(buttons);
        }
    }, [conf, conf?.configuration, location.state?.configuration]);

    const setfil = (obj) => setfilter(prev => ({ ...prev, ...obj }));

    const getChartRef = useCallback((idx) => chartRefs.current[idx] ??= React.createRef(), []);

    const Cancel = () => {
        setOpenDialogCompany(false);
        navigate(-1);
    };

    const handleConfirmAction = useCallback(async (values) => {
        const flt = {
            "id_company": {
                "value": values.id_company,
                "operator": "=",
                "type": "string"
            }
        }
        setfil(flt);
        setOpenDialogCompany(false);
    }, []);

    useEffect(() => {
        if (location.state && location.state.config && location.state?.config?.id_user_action) {
            const { id_user_action } = location.state.config;
            const fetchDataCompany = async () => {
                try {
                    const response = await callApi('company_select', 'SELECT_COMPANIES_BY_USER_ACTION', { id_user_action }, userSession.token);
                    const compns = ensureArray(response.data);
                    setCompanies(compns);
                    if (compns.length === 1) {
                        const flt = {
                            "id_company": {
                                "value": compns[0].id_company,
                                "operator": "=",
                                "type": "string"
                            }
                        }
                        setfil(flt);
                        setOpenDialogCompany(false);
                    }
                    else
                        setOpenDialogCompany(true);
                } catch (e) {
                    console.error(e.message);
                } finally {
                    setLoading(false);
                }
            }
            fetchDataCompany();
        }
        else
            setLoading(false);
    }, [])

    const handleExport = (idx) => {
        const ref = chartRefs.current[idx];
        if (ref && ref.current && ref.current.exportChartData) {
            ref.current.exportChartData();
        } else {
            console.error(`Referencia o función de exportación no encontrada para el índice ${idx}`);
        }
    };

    return (

        <Box sx={{ width: '100%' }} className='custom-hard-table-zd-nix'>
            <Box sx={{ mb: 2, pt: 2, pl: 2, pr: 2 }}>
                <Box
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}
                >
                    <Breadcrumbs aria-label='breadcrumb' separator='›' sx={{ mb: 3 }}>
                        <Link underline='hover' color='text.main' sx={{ cursor: 'pointer' }}>
                            <Typography sx={{ fontWeight: 'bold' }}>
                                {cfg?.title ? cfg.title : 'Reportes'}
                            </Typography>
                        </Link>
                    </Breadcrumbs>
                    <Grid>
                        <LoadButtonHeaderTable
                            buttons={buttons}
                            id_user_action={''}
                            DocManager={null}
                            columns={[]}
                            handleChange={setfil}
                        />
                    </Grid>
                </Box>
            </Box>

            <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(12, 1fr)",
                gridTemplateRows: "repeat(12, minmax(calc(1200px / 12), auto))",
                gridAutoRows: "minmax(calc(1200px / 12), auto)",
                gap: "10px",
                minHeight: "1200px",
                height: "auto",
            }}>
                {!loading && (
                    charts.map((item, idx) => {
                        const currentRef = getChartRef(idx);
                        return (
                            <Box
                                key={idx}
                                style={{
                                    // borderRadius: "12px",
                                    position: "relative",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    background: "#fff",
                                    ...item.chart?.size || item.config?.size || {}
                                }}
                            >
                                {item?.download &&
                                    <IconButton
                                        size="small"
                                        title="Exportar a Excel"
                                        sx={{
                                            position: "absolute",
                                            top: 8,
                                            right: 8,
                                            zIndex: 1000,
                                            backgroundColor: "rgba(255,255,255,0.95)",
                                            boxShadow: 2,
                                            "&:hover": { backgroundColor: "#f0f0f0" }
                                        }}
                                        onClick={() => handleExport(idx)}
                                    >
                                        <GetAppIcon color="success" fontSize="small" />
                                    </IconButton>
                                }
                                <Box
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        overflow: item.type === 'gridPivot' ? "auto" : "hidden",
                                        minWidth: item.type === 'gridPivot' ? 0 : undefined,
                                        minHeight: item.type === 'gridPivot' ? 0 : undefined
                                    }}
                                >
                                    {item.type === 'area' && <AreaChart data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'complexColumn' && <ComplexColumnChart data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'simpleColumn' && <SimpleColumnChart data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'line' && <LineChart data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'pie' && <PieChart data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'funnel' && <FunnelChart data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'stackedColumn' && <StackedColumnChart data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'gridPivot' && <GridPivot data={item} filters={filters} returnData={exportToExcel} ref={currentRef} />}
                                    {item.type === 'card' && <StatCard data={item} filters={filters} />}
                                    {item.type === 'doughnut' && <DoughnutChart data={item} filters={filters} />}
                                    {item.type === 'groupBars' && <BarGroupChart data={item} filters={filters} />}
                                    {item.type === 'simpleBars' && <BarChart data={item} filters={filters} />}
                                    {item.type === 'simpleLine' && <SimpleLineChart data={item} filters={filters} />}
                                </Box>
                            </Box>
                        );
                    })
                )}
            </div>

            <DialogSelectCompany
                openDialogConfirm={openDialogCompany}
                handleCancelConfirm={Cancel}
                handleConfirmAction={handleConfirmAction}
                data={companies}
            />
            {loading && <LoadingOverlay isOpen={loading} />}
        </Box>
    );
}